<template>
  <!-- Le catalogue des produits vendus par les stores (REDMINE-13522). Billing
       y reconnait ce que l'app a achete : un produit absent refuse l'achat. -->
  <div class="index py-5">
    <div class="d-flex align-center">
      <span class="d-flex flex-row page-title">{{ $t('intranet.title.menu.billing.products') }}</span>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="edit({ store: 'apple', period: 'month', active: true })">
        {{ $t('intranet.billing.addProduct') }}
      </v-btn>
    </div>

    <div class="searchable-list-container">
      <v-data-table :headers="headers" :items="items" :loading="loading" hide-default-footer :items-per-page="-1">
        <template v-slot:item.period="{ item }">{{ $t(`intranet.billing.periods.${item.period}`) }}</template>
        <template v-slot:item.active="{ item }">
          <v-chip small :color="item.active ? 'success' : 'grey lighten-1'">
            {{ item.active ? $t('intranet.billing.yes') : $t('intranet.billing.no') }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="edit(item)"><v-icon>mdi-pencil</v-icon></v-btn>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialog" max-width="560">
      <v-card v-if="editing">
        <v-card-title>{{ editing.id ? $t('intranet.billing.editProduct') : $t('intranet.billing.addProduct') }}</v-card-title>
        <v-card-text>
          <v-select v-model="editing.store" :items="['apple', 'google']" :label="$t('intranet.billing.store')" :disabled="!!editing.id"></v-select>
          <v-text-field v-model="editing['product-id']" :label="$t('intranet.billing.product')" :hint="$t('intranet.billing.productIdHint')" persistent-hint :disabled="!!editing.id"></v-text-field>
          <v-text-field v-if="editing.store === 'google'" v-model="editing['base-plan-id']" :label="$t('intranet.billing.basePlan')" :hint="$t('intranet.billing.basePlanHint')" persistent-hint :disabled="!!editing.id"></v-text-field>
          <v-select v-model="editing.period" :items="periods" :label="$t('intranet.billing.period')"></v-select>
          <v-switch v-model="editing.active" :label="$t('intranet.billing.active')" :hint="$t('intranet.billing.activeHint')" persistent-hint></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">{{ $t('intranet.referential.button.cancel') }}</v-btn>
          <v-btn color="primary" text :disabled="!editing['product-id']" @click="save()">{{ $t('intranet.referential.button.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { errorHandler } from 'aveine-toolbox'
import { search, saveProduct } from '@/components/billing/billing-api'

export default {
  name: 'BillingProducts',
  data () {
    return { items: [], loading: false, dialog: false, editing: null }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('intranet.billing.store'), value: 'store', sortable: false },
        { text: this.$t('intranet.billing.product'), value: 'product-id', sortable: false },
        { text: this.$t('intranet.billing.basePlan'), value: 'base-plan-id', sortable: false },
        { text: this.$t('intranet.billing.period'), value: 'period', sortable: false },
        { text: this.$t('intranet.billing.active'), value: 'active', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end', width: 80 }
      ]
    },
    periods () {
      return ['month', 'year'].map(value => ({ value, text: this.$t(`intranet.billing.periods.${value}`) }))
    }
  },
  methods: {
    // Une copie : annuler la fenetre ne doit rien laisser dans la liste.
    edit (product) {
      this.editing = { ...product }
      this.dialog = true
    },
    async save () {
      try {
        await saveProduct(this.$auth, this.editing)
        this.dialog = false
        this.load()
      } catch (errors) {
        errorHandler(errors, this)
      }
    },
    async load () {
      this.loading = true
      try {
        this.items = (await search(this.$auth, '/billing-products', { sort: 'store,product-id', 'page[size]': 100 })).items
      } catch (errors) {
        errorHandler(errors, this)
      } finally {
        this.loading = false
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
